const CheckState = {
  Wait: 'WA',
  Temp: 'TS',
  Updated: 'TR',
};

Object.freeze(CheckState);

export default CheckState;
